"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinearProgress = _interopRequireDefault(require("@eig-builder/core-ui/LinearProgress"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// import EXIF from 'exif-js'
var ImageCanvasSingle = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageCanvasSingle, _React$Component);

  var _super = _createSuper(ImageCanvasSingle);

  function ImageCanvasSingle() {
    var _this;

    (0, _classCallCheck2["default"])(this, ImageCanvasSingle);
    _this = _super.call(this);
    _this.componentDidMount = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var file, theTempBase64;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = _this.props.file;

              if (!file.file) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this.getBase64(file.file);

            case 4:
              theTempBase64 = _context.sent;

              _this.setState({
                base64: theTempBase64
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this.fileCanvas = _react["default"].createRef();
    _this.state = {
      base64: null
    };
    return _this;
  }

  (0, _createClass2["default"])(ImageCanvasSingle, [{
    key: "getBase64",
    value: function getBase64(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new window.FileReader();

        fileReader.onload = function () {
          resolve(fileReader.result);
        };

        fileReader.readAsDataURL(file);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          uploaded = _this$props.uploaded,
          file = _this$props.file,
          progress = _this$props.progress;
      var base64 = this.state.base64;

      if (file.url) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "file-container",
          onClick: function onClick() {
            return onSelect(file.url, uploaded);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "image-wrapper"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: base64
        })));
      }

      if (file.skip) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "file-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "image-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: base64,
        style: {
          opacity: '0.5'
        }
      }), /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
        progressMode: "determinate",
        progress: progress,
        show: true
      })));
    }
  }]);
  return ImageCanvasSingle;
}(_react["default"].Component);

exports["default"] = ImageCanvasSingle;
ImageCanvasSingle.propTypes = {
  file: _propTypes["default"].object.isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  uploaded: _propTypes["default"].bool,
  progress: _propTypes["default"].any
};